import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { strings } from '../../../assets/strings/all';
const ShouldDeleteTeamModal = (props) => {
  const { common, cases } = strings;
  const { open, close, removeTeam } = props;
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  return (
    <Modal size="md" show={open} onHide={close} centered>
      <Modal.Header>
        {' '}
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '1.2rem',
          }}
        >
          {cases.deleting_team}
        </div>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '14px' }}>{cases.deleting_team_message}</div>
        {loading && <div>{cases.loading}</div>}
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
        }}
      >
        <Button
          disabled={loading}
          variant="danger"
          onClick={async () => {
            setLoading(true);
            await removeTeam();
            close();
            setLoading(false);
          }}
        >
          {common.delete}
        </Button>
        <Button disabled={loading} variant="outline-dark" onClick={close}>
          {common.cancel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShouldDeleteTeamModal;
